import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";

export default class OrderWithAuthorizationAndPaymentProofResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "order": {
                    "number": 1,
                    "state": "INITIAL",
                    "customer": {
                        "code": 5,
                        "business_name": 2,
                        "number": 2,
                        "fantasy_name": "Customer",
                        "delivery_sites": [{
                            "name": "Customer Delivery Site",
                            "address": "Address",
                            "city": "City",
                        }],
                    },
                    "delivery_site": {
                        "name": "Customer Delivery Site",
                        "address": "Address",
                        "city": "City",
                    },
                    "delivery_date": "20-05-2024",
                    "observations": "An Observation",
                    "articles": [
                        {
                            "article": {
                                "code": "1",
                                "name": "Articulo",
                                "fantasy_name": "Articulo Fantasia",
                                "items_amount": "20",
                                "category": {
                                    "name": "Categoria",
                                    "title": "Titulo Categoria",
                                    "description": "Descripcion Categoria"
                                }
                            },
                            "quantity": 4,
                            "discount": 0,
                        },
                        {
                            // Only if state is INVOICED
                            "article": {
                                "code": "1",
                                "name": "Articulo",
                                "fantasy_name": "Articulo Fantasia",
                                "items_amount": "20",
                                "category": {
                                    "name": "Categoria",
                                    "title": "Titulo Categoria",
                                    "description": "Descripcion Categoria"
                                }
                            },
                            "quantity": 4,
                            "discount": 0,
                            "unit_price": {
                                'amount': 60.00,
                                'currency': "ARS"
                            },
                            "price": {
                                'amount': 1200.00,
                                'currency': "ARS"
                            }
                        }]
                },
                "authorization": {
                    'state': "PENDING",
                    'observations': "An Observation",
                },
                "advance_payment_proof": {
                    'order_number': 'ORD-001',
                    'file': { 
                        'name': 'comprobante.pdf', 
                        'url': '/media/advance_payment_proofs/comprobante.pdf' 
                    },
                    'creation_datetime': '01-01-2024 10:30:00'
                },
                "advance_payment_required": false,
            },
            errors: []
        }
    }

    order() {
        return {
            number: this.number(),
            purchaseOrderNumber: this.purchaseOrderNumber(),
            state: this.state(),
            customer: this.customer(),
            deliverySite: this.deliverySite(),
            deliveryDate: this.deliveryDate(),
            observations: this.observations(),
            articles: this.articles(),
            isFree: this.isFree(),
        }
    }

    number() {
        return this.content().order.number;
    }

    isFree() {
        return this.content().order.is_free || false;
    }

    purchaseOrderNumber() {
        return this.content().order.customers_order_number;
    }

    state() {
        return this.content().order.state;
    }

    customer() {
        const customer = this.content().order.customer
        return {
            code: customer.code,
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }

    deliverySite() {
        const deliverySite = this.content().order.delivery_site
        return {
            deliverySiteCode: deliverySite.code,
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliveryDate: "",
        }
    }

    deliveryDate() {
        const deliveryDate = this.content().order.delivery_date;
        return dayjs(deliveryDate, 'DD-MM-YYYY');
    }

    observations() {
        return this.content().order.observations
    }

    articles() {
        const state = this.content().order.state;
        
        return this.content().order.articles.map(articleWithAmount => {
                const article = {
                    code: articleWithAmount.article.code,
                    name: articleWithAmount.article.name,
                    family: articleWithAmount.article.category.name,
                    amount: articleWithAmount.quantity,
                    discount: articleWithAmount.discount
                }
                if (state === 'INVOICED') {
                    article.fantasyName = articleWithAmount.article.fantasy_name
                    article.price = articleWithAmount.price
                    article.unitPrice = articleWithAmount.unit_price
                }

                return article
            }
        )
    }

    authorization() {
        return this.content().authorization
    }

    advancePaymentProof() {
        const advance_payment_proof = this.content().advance_payment_proof;

        if (!advance_payment_proof || Object.keys(advance_payment_proof).length === 0) {
            return { file: {}, orderNumber: '', creationDateTime: '' };
        }

        const file = advance_payment_proof.file;
        return {
            file: { name: file.name, url: file.url },
            orderNumber: advance_payment_proof.order_number,
            creationDateTime: advance_payment_proof.creation_datetime
        }
    }

    advancePaymentRequired() {
        return this.content().advance_payment_required;
    }
}